<template>
  <div>
    <div id="loginbox">
      <img src="@/assets/img/baidu/baidulytd/indexbg.png" />
      <!-- 百度优选新店-联盈通达企业店 表单 -->
      <van-form class="bform" ref="form" @submit="submit">
        <div class="bform-title">
          <img src="@/assets/img/baidu/baidulytd/form_info.png" />
          <div>百度券码信息</div>
        </div>
        <van-field
          class="bform-input"
          placeholder="请输入百度券码信息"
          v-model="form.redeemCode"
          name="redeemCode"
          :rules="[
            {
              required: true,
              message: '请输入百度券码信息'
            }
          ]"
        />
        <div class="bform-title">
          <img src="@/assets/img/baidu/baidulytd/form_phone.png" />
          <div>下单手机号</div>
        </div>
        <van-field
          class="bform-input"
          placeholder="请输入下单手机号"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的下单手机号'
            }
          ]"
        />
        <div class="bform-title">
          <img src="@/assets/img/baidu/baidulytd/form_yzm.png" />
          <div>手机号验证码</div>
        </div>
        <van-field
          class="bform-input yzm"
          placeholder="请输入手机号验证码"
          v-model="form.captchaCode"
          :rules="[
            {
              required: true,
              message: '请输入手机号验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">获取验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="loading"
          loading-text="兑换中"
          native-type="submit"
        >
          马上兑换
        </van-button>
      </van-form>
    </div>

    <!-- 确认弹框 -->
    <van-dialog
      v-model="confirmVisible"
      :showConfirmButton="false"
      class="reset-dialog"
    >
      <div class="operations">
        <van-button
          color="linear-gradient(90deg, #FDA253, #FB3A00)"
          @click="confirmSubmit()"
          v-if="!confirmTime"
        >
          确认
        </van-button>
        <!-- 确认倒计时 -->
        <van-button color="#CACACA" v-if="confirmTime">
          确认
          <van-count-down
            class="confirmdown"
            format="ss s"
            :time="confirmTime"
            @finish="confirmTime = 0"
          />
        </van-button>
        <van-button
          class="cancel"
          color="#CACACA"
          @click=";(confirmVisible = false), (confirmTime = 0)"
        >
          取消
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { baiduCheck, getCaptcha } from '@/api/baidu.js'
export default {
  data() {
    return {
      time: 0,
      loading: false,
      form: {
        redeemCode: undefined,
        phone: undefined,
        captchaCode: null
      },
      confirmVisible: false,
      confirmTime: 0
    }
  },
  mounted() {},
  methods: {
    async submit() {
      this.confirmTime = 15000
      this.confirmVisible = true
    },
    async confirmSubmit() {
      try {
        this.confirmTime = 0
        this.confirmVisible = false
        this.loading = true
        const { code, data, message } = await baiduCheck({
          ...this.form,
          customerNo: this.$route.query?.customerNo || undefined
        })
        this.loading = false
        switch (code) {
          case 0:
            this.$router.push({
              path: '/baidulytdList',
              query: { token: data }
            })
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.loading = false
      }
    },
    async sendCode() {
      await this.$refs.form.validate('redeemCode')
      await this.$refs.form.validate('phone')
      const { code, message } = await getCaptcha({
        ...this.form,
        customerNo: this.$route.query?.customerNo || undefined
      })
      if (code === 0) {
        this.time = 60000
      } else {
        this.$toast.fail({
          message: message
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-field__control::placeholder,
/deep/.van-field--error .van-field__control::placeholder {
  color: #adb0b3;
}
#loginbox {
  background: #fff;
  min-height: 100vh;
  & > img {
    width: 100%;
  }
  .bform {
    padding: 0% 64px 40px;
    box-sizing: border-box;
    border-radius: 15px;
    .bform-title {
      font-size: 28px;
      color: #000000;
      padding: 42px 32px 0px;
      display: flex;
      justify-content: flex-start;
      img {
        width: 28px;
        display: block;
        margin-right: 16px;
      }
    }
    .yzm {
      display: flex;
    }
    /deep/ .van-field__error-message {
      line-height: 60px;
    }
    .submit {
      width: 100%;
      height: 104px;
      background: linear-gradient(90deg, #fda253, #fb3a00);
      border-radius: 52px;
      text-align: center;
      color: #ffffff;
      font-size: 40px;
      margin-top: 80px;
    }
  }
  .cdown {
    flex: 1;
    text-align: center;
    color: #fb3a00;
    box-sizing: border-box;
    padding-left: 3.77vw;
  }
}
.reset-dialog {
  background: url('~@/assets/img/baidu/baidulytd/reset_dialog.png');
  width: 570px;
  height: 672px;
  margin: auto;
  background-size: 100% auto;
  .operations {
    position: absolute;
    bottom: 95px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    .van-button {
      width: 200px;
      border-radius: 50px;
      box-sizing: border-box;
      font-size: 36px;
      padding: 0;
    }
    .cancel {
      margin-left: 20px;
    }
    .confirmdown {
      display: inline;
      color: #fff;
    }
  }
}
</style>
